import _ from 'lodash'
import getFrontendBaseUrl from './getFrontendBaseUrl'

const MULTI_FILTER_KEYS = ['companyId', 'carType', 'seats', 'transmission', 'insurance', 'fuelPolicy', 'rate']
const LOCATION_FILTER_KEYS = ['fulfillment', 'governorate', 'location', 'lat', 'lon']

const appendParam = (params, key, value) => {
  if (_.isNil(value) || value === '') return

  if (_.isArray(value)) {
    const cleaned = value.map(v => _.trim(String(v))).filter(Boolean)
    if (cleaned.length > 0) {
      params.set(key, cleaned.join(','))
    }
    return
  }

  const str = _.trim(String(value))
  if (str) {
    params.set(key, str)
  }
}

/**
 * Build website car listing URL from sidebar filter config.
 * @param {Record<string, string|string[]>} listingFilters
 * @param {{ pathname?: string, search?: string } | null} location
 */
export function buildCarListingUrl(listingFilters = {}, location = null) {
  const baseUrl = (getFrontendBaseUrl(location) || '').replace(/\/$/, '')
  const params = new URLSearchParams()

  if (_.isObject(listingFilters)) {
    _.forEach(MULTI_FILTER_KEYS, key => {
      appendParam(params, key, listingFilters[key])
    })

    const normalizePriceParam = value => {
      if (_.isNil(value) || value === '') return undefined
      const cleaned = String(value).replace(/[^\d.]/g, '')
      if (!cleaned || cleaned === '.') return undefined
      const n = Number(cleaned)
      return Number.isFinite(n) && n >= 0 ? n : undefined
    }
    const priceFrom = normalizePriceParam(listingFilters.priceRange_from ?? listingFilters.priceRange?.from)
    const priceTo = normalizePriceParam(listingFilters.priceRange_to ?? listingFilters.priceRange?.to)
    appendParam(params, 'priceRange_from', priceFrom)
    appendParam(params, 'priceRange_to', priceTo)

    // Pickup / delivery targeting (encoded into linkUrl for storefront + mobile)
    _.forEach(LOCATION_FILTER_KEYS, key => {
      appendParam(params, key, listingFilters[key])
    })
  }

  const qs = params.toString()
  return qs ? `${baseUrl}/search/?${qs}` : `${baseUrl}/search/`
}

/**
 * Build website car detail URL.
 * @param {string} rentalCarId
 * @param {{ pathname?: string, search?: string } | null} location
 */
export function buildCarDetailUrl(rentalCarId, location = null) {
  const baseUrl = (getFrontendBaseUrl(location) || '').replace(/\/$/, '')
  if (!rentalCarId) return ''
  return `${baseUrl}/car/${rentalCarId}/`
}

/**
 * Resolve link URL from banner type and config.
 */
export function buildBannerLinkUrl({ bannerType, listingFilters, carDetailTarget }, location = null) {
  if (bannerType === 'carDetail') {
    return buildCarDetailUrl(carDetailTarget?.rentalCarId, location)
  }
  if (bannerType === 'carListing') {
    return buildCarListingUrl(listingFilters, location)
  }
  return ''
}

export const ALLOWED_LISTING_FILTER_TYPES = ['carType', 'seats', 'transmission', 'insurance', 'fuelPolicy', 'rate', 'priceRange']
